import React from 'react';

import LowUsageIcon from '../../../assets/icons/common/usage/LowUsageIcon';
import MediumUsageIcon from '../../../assets/icons/common/usage/MediumUsageIcon';
import HighUsageIcon from '../../../assets/icons/common/usage/HighUsageIcon';

import styles from './styles.module.scss';

const usageIcons = {
  'Low Usage': LowUsageIcon,
  'Medium Usage': MediumUsageIcon,
  'High Usage': HighUsageIcon,
  'Out Of Data': HighUsageIcon,
};

const DeviceUsageType = ({ usageType }) => {
  const UsageIcon = usageIcons[usageType];

  if (!UsageIcon) {
    return null;
  }

  return (
    <div className={styles.deviceUsageType}>
      <UsageIcon></UsageIcon> {usageType}
    </div>
  );
};

export default DeviceUsageType;
